import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5045d400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-view d-flex flex-column align-items-center col-12 pb-3 pb-md-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-primary col-12 px-2 py-3 py-md-5 flex-centered-col bg-image" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "m-0 text-uppercase text-white" }, "My Profile")
  ])
], -1))
const _hoisted_3 = { class: "d-flex p-2 p-md-0 justify-content-center" }
const _hoisted_4 = { class: "col-12 col-md-11 col-xl-10 col-xxl-9 p-2 p-md-3 flex-centered-col" }
const _hoisted_5 = { class: "rounded shadow bg-light px-3 px-md-5 py-3 py-md-4" }
const _hoisted_6 = { class: "form" }

import ProfileForm from "@/components/forms/ProfileForm.vue";
import { useHead } from "@unhead/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

useHead({
  title: "Profile",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ProfileForm)
          ])
        ])
      ])
    ])
  ]))
}
}

})